import { showToast } from "@/components/feedback"
import { Button, Text } from "@/components/ui"
import { undoCouponReplacement } from "@/lib/coupon-arrival"

/** Tells the customer the newest coupon took the place of the others (they do not combine), with a one-tap "desfazer". */
export function showCouponReplacedToast(merchantId: string, code: string, replaced: readonly string[]): void {
  if (replaced.length === 0) return
  showToast.info(
    <Text as="span" size="sm">
      Trocamos pelo cupom <Text as="strong" weight="bold">{code}</Text> ·{" "}
      <Button variant="link" tone="primary" size="auto" weight="semibold" onClick={() => undoCouponReplacement(merchantId, code, replaced)}>
        <Text as="span" size="sm">
          desfazer
        </Text>
      </Button>
    </Text>,
  )
}
